import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { LineLoader, PermissionFilter } from '@timmons-group/shared-react-components';

import { useAuth } from '@timmons-group/shared-react-components/hooks';
import { AUTH_STATES } from '@timmons-group/shared-react-components/constants';
import { ACLS } from 'constants';

// Pages
import Layout from 'pages/Layout';
import Home from 'pages/Home';
import Communities from 'PAM/pages/Communities';
import Plans from 'PAM/pages/Plans';
import HVRA from 'HVRA/pages/Explorer';
import NewCommunityArea from 'PAM/pages/NewCommunityArea';
import ViewCommunity from 'PAM/pages/ViewCommunity';
import CommunityPlanForm from 'PAM/pages/CommunityPlanForm';

const AppRoutes = () => {
  // This hook is a useContext for the ProvideAuth contextProvider found in AppWrapper.js
  // It is used to get the auth object and dispatch actions to it
  // The useProvideAuth in useAuth.js contains the exposed properties and methods
  const { authState } = useAuth();

  // Use this to debug the auth state if needed
  // useEffect(() => {
  //   console.log('Auth:', authState, authState.state === AUTH_STATES.LOGGING_IN)
  // }, [authState.state]);

  // This is a modified take on the official react-router-dom Auth example:
  // https://reactrouter.com/docs/en/v6/examples/auth
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          {(authState.state === AUTH_STATES.LOGGING_IN) ?
            // This will put a placeholder route in that matches anything while logging in
            // This way we dont forget the user's current location
            // Once logged in they get the right outlet if they have access to it
            (<>
              <Route index element={
                <Home />
              }/>
              <Route path="*" element={
                <LineLoader color="primary" message="Logging you in..." />
              } />
            </>) :
            (<>
              <Route index element={
                <Home />
              }
              />
              <Route path="communities" element={
                <PermissionFilter isRoute={true} permission={ACLS.VIEW_COMMUNITIES}>
                  <Communities />
                </PermissionFilter>
              } />
              <Route path="explorer/hvra" element={
                <PermissionFilter isRoute={true} permission={ACLS.VIEW_EXPLORER}>
                  <HVRA />
                </PermissionFilter>
              } />
              <Route path="pam">
                <Route path="plans" element={
                  <PermissionFilter isRoute={true} permission={ACLS.VIEW_PLANS}>
                    <Plans />
                  </PermissionFilter>
                } />
                <Route path="communityArea">
                  <Route path="create" element={
                    <PermissionFilter isRoute={true} all={[ACLS.ADD_PLANNING_AREA, ACLS.ADD_COMMUNITY]}>
                      <NewCommunityArea />
                    </PermissionFilter>
                  } />
                  <Route path=":id/*" element={
                    <PermissionFilter isRoute={true} permission={ACLS.VIEW_COMMUNITIES}>
                      <ViewCommunity />
                    </PermissionFilter>
                  } />
                  <Route path=":id/addPlan" element={
                    <PermissionFilter isRoute={true} permission={ACLS.ADD_PLANNING_AREA}>
                      <CommunityPlanForm />
                    </PermissionFilter>
                  } />
                  <Route path=":id/editPlan/:planId" element={
                    <PermissionFilter isRoute={true} permission={ACLS.ADD_PLANNING_AREA}>
                      <CommunityPlanForm />
                    </PermissionFilter>
                  } />
                </Route>
              </Route>
            </>)
          }
        </Route>
      </Routes>
    </>
  )
}

export default AppRoutes;